module.exports = "https://static.wanderu.com/ui-react/_next/static/media/mashable.68f79d9f.png";